import axios from 'axios';
import { DeviceType } from '../interfaces/api/deviceType';

export interface DeviceTypeFilterParams {
	search?: string;
	organization?: string;
	modalities?: string[];
	fields?: string;
}

function queryBuilderDeviceType(params: DeviceTypeFilterParams): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.search) {
		queryParams.append('search', params.search);
	}
	if (params.organization) {
		queryParams.append('organization', params.organization);
	}
	if (params.modalities && params.modalities.length > 0) {
		for (const modality of params.modalities) {
			queryParams.append('modality', modality);
		}
	}
	if (params.fields) {
		queryParams.append('fields', params.fields);
	}
	return queryParams;
}

export async function getDeviceTypes(params: DeviceTypeFilterParams = {}): Promise<DeviceType[]> {
	try {
		const queryParams = queryBuilderDeviceType(params);
		const response = await axios.get<DeviceType[]>('api/device_types/', {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getDeviceType(
	id: number,
	params: DeviceTypeFilterParams = {}
): Promise<DeviceType> {
	try {
		const queryParams = queryBuilderDeviceType(params);
		const response = await axios.get<DeviceType>(`api/device_types/${id}/`, {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
